import { ApiTypes } from '../../types';
export function isGroupPrivate(group) {
    return group.settings.privacyLevel === ApiTypes.v1.GroupPrivacyLevel.PRIVATE;
}
export function isGroupPublic(group) {
    return group.settings.privacyLevel === ApiTypes.v1.GroupPrivacyLevel.PUBLIC;
}
export function isGroupSecret(group) {
    return group.settings.privacyLevel === ApiTypes.v1.GroupPrivacyLevel.SECRET;
}
export function isEmptyGroup(group) {
    return !group.groupId;
}
export function isDefaultGroup(group) {
    return group.groupId === 'dummy_group_id';
}
export function isPendingGroup(group) {
    return group.approvalStatus === ApiTypes.v1.GroupApprovalStatus.PENDING;
}
//# sourceMappingURL=GroupPrivacy.js.map